import React from 'react'

export type ScaleType = 'n' | 'n_pct'

type ControlProps = {
    isDisabled: boolean
    scaleType: ScaleType
    onScaleTypeChange: (value: ScaleType) => void
    showLeagueAverages: boolean
    onShowLeagueAveragesChange: (value: boolean) => void
}

export default function Controls({
    isDisabled,
    scaleType,
    onScaleTypeChange,
    showLeagueAverages,
    onShowLeagueAveragesChange,
}: ControlProps) {
    function handleScaleChange(e: React.ChangeEvent<HTMLSelectElement>) {
        onScaleTypeChange(e.target.value as ScaleType)
    }

    function handleLeagueAverageChange(
        e: React.ChangeEvent<HTMLSelectElement>
    ) {
        onShowLeagueAveragesChange(e.target.value === 'show')
    }

    // Can only show league averages when using percentage scale
    const canShowLeagueAverages = scaleType === 'n_pct'

    return (
        <div className="swing-timing-controls">
            <div className="savant-select" data-title="Scale">
                <select
                    value={scaleType}
                    onChange={handleScaleChange}
                    disabled={isDisabled}
                >
                    <option value="n">Raw Swing Totals</option>
                    <option value="n_pct">Percent Total Swings</option>
                </select>
            </div>
            <div className="savant-select" data-title="League Average">
                <select
                    value={showLeagueAverages ? 'show' : 'hide'}
                    onChange={handleLeagueAverageChange}
                    disabled={isDisabled || !canShowLeagueAverages}
                >
                    <option value="hide">Hide</option>
                    <option value="show">Show</option>
                </select>
            </div>
        </div>
    )
}
